import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "badge bg-info-soft"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { storeToRefs } from "pinia";
import { useSessionStore } from "@/store/useSessionStore";
import { languages } from "../utils/languages";

// ?.: a sessão fica nula por um instante ao sair, com a tela ainda montada

export default /*@__PURE__*/_defineComponent({
  __name: 'TimezoneAlert',
  props: {
    icon: { type: Boolean }
  },
  setup(__props: any) {

const { session } = storeToRefs(useSessionStore());



return (_ctx: any,_cache: any) => {
  return (_unref(session)?.foreigner)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa-solid fa-clock me-1" }, null, -1)),
        (__props.icon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(languages)["pt-br"].flag), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, "Horário de Brasília"))
      ]))
    : _createCommentVNode("", true)
}
}

})